import './style/main.scss'
import 'theme/logo-full.png' // Do not remove - used in email-receipts
import { applyMiddleware, compose, createStore } from 'redux'
import { loadState, stateVersion } from 'utilities/localStorage'
import { AppContainer } from 'react-hot-loader'
import { Provider } from 'react-redux'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import Router from 'components/Router'
import { createBrowserHistory } from 'history'
import createRootReducer from './reducers'
import 'utilities/i18n'
import { init, initLocation } from 'utilities/init'
import merge from 'lodash/merge'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { baseState as uiBaseState } from './reducers/uiReducer'
import smoothscroll from 'smoothscroll-polyfill'
import { sentryReduxEnhancer } from 'common/middleware/sentry'
import { googleAnalyticsMiddleware } from 'common/middleware/analytics'

stateVersion('1.0.8')

const history = createBrowserHistory()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const persistedState = loadState()
const store = createStore(
    createRootReducer(history),
    persistedState && merge({ ui: uiBaseState }, persistedState),
    composeEnhancers(
        applyMiddleware(routerMiddleware(history), thunk, googleAnalyticsMiddleware),
        sentryReduxEnhancer
    )
)

init(store)

// Enable smooth scroll in Safari
smoothscroll.polyfill()

const appNode = document.querySelector('#app')
const render = (Router) => {
    ReactDOM.render(
        <Suspense fallback={<div />}>
            <AppContainer>
                <Provider store={store}>
                    <Router history={history} />
                </Provider>
            </AppContainer>
        </Suspense>,
        appNode
    )
}

export const rerender = () => {
    initLocation(store)
    ReactDOM.unmountComponentAtNode(appNode)
    render(Router)
}

render(Router)

if (module.hot) {
    module.hot.accept('components/Router', () => render(Router))
}
